<template>
	<div class="index">
		<div class="page-head">
			<the-head></the-head>
		</div>
		<div class="router-view-box">
			<router-view></router-view>
		</div>
		<div class="page-foot">
			<the-foot></the-foot>
		</div>
	</div>
</template>

<script>
import TheHead from '@/views/home/components/head';
import TheFoot from '@/views/home/components/foot';
export default {
	name: 'Index',
	components: { TheHead, TheFoot }
};
</script>

<style lang="scss" scoped>
.index {
	width: 100%;
	height: 100vh;
	overflow: hidden;
	display: flex;
	flex-direction: column;
	.page-head {
		width: 100%;
		height: fit-content;
		flex-shrink: 1;
	}
	.router-view-box {
		width: 100%;
		flex: 1 1 auto;
		overflow: hidden;
		// overflow: auto;
		// 	box-sizing: border-box;
	}
	.page-foot {
		width: 100%;
		height: fit-content;
		flex-shrink: 1;
	}
}
</style>
